/* eslint-disable react-hooks/exhaustive-deps */
import { use721Contract } from "hooks/useContract";
import { useEffect, useState } from "react";

const CounterSection: React.FC = () => {
  const [supply, setSupply] = useState(0);
  const contract = use721Contract();

  const getSupply = async () => setSupply(await contract.totalSupply());
  useEffect(() => {
    getSupply();
  }, [contract]);
  
  return (
    <section className="counter counter--uplifted">
      <div className="container">
        <div className="counter__wrapper">
          <div className="row g-1">
            <div className="col-lg-4 col-sm-8">
              <div className="counter__item">
                <div className="counter__item-content">
                  <h2>
                    <span
                      className="purecounter"
                      data-purecounter-start="0"
                      data-purecounter-end="2000"
                      data-purecounter-duration="0"
                    >
                      5000
                    </span>
                  </h2>
                  <p>Total items</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-8">
              <div className="counter__item">
                <div className="counter__item-content">
                  <h2>
                    <span
                      className="purecounter"
                      data-purecounter-start="0"
                      data-purecounter-end="100"
                      data-purecounter-once="false"
                    >
                      {supply.toString()}
                    </span>
                  </h2>
                  <p>Total Minted</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-8">
              <div className="counter__item">
                <div className="counter__item-content">
                  <h2>
                    <span
                      className="purecounter"
                      data-purecounter-start="10"
                      data-purecounter-end="15"
                      data-purecounter-once="false"
                    >
                     0.001
                    </span>
                  </h2>
                  <p>floor price [Matic]</p>
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </section>
  );
};
export default CounterSection;
